export default [
    {
        path: '/audit',
        name: 'audit',
        component: () => import('@/views/pages/audit/AuditPage.vue'),
        meta: {
            resource: 'Audit',
            action: 'manage',
            pageTitle: 'Audit',
            breadcrumb: [{ text: 'Audit', active: true }],
        },
    },
]
